import * as yup from 'yup';

const participantFieldSchema = yup.object().shape({
  title: yup.string().ensure().required(),
  choices: yup.array(yup.object({
    title: yup.string().ensure().required(),
  })),
  validation_url: yup.string().nullable(),
  validation_success_response: yup.string().nullable(),
});

export default participantFieldSchema;
